import { Toolbar } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { DashboardHead } from '../../Dashboard/DashboardPage'
import { DataTable, FilterSection, SelectField, ToolbarComponent } from '../../../../../components'
import { studentHeadCells, studentPresenceHeadCells } from '../../../../../shared/data/headCells'
import { useGlobal } from '../../../../../shared'
import { urls } from '../../../../../shared/config'
import { useDispatch, useSelector } from 'react-redux'
import { InfoField } from '../School/PopOver/SchoolInfo'
import { highestInt } from '../../../../../shared/utils/constants'
import { ExportIcon, ImportIcon } from '../../../../../assets/icons'
import {
  setOpenExportModal,
  setOpenImport,
  setOpenTransportModal,
} from '../../../../../redux/globalSlice'
import classes from './Student.module.css'
import DashboardCard from '../../Dashboard/component/Card'
import NewSelectedField from '../../../../../common/NewSelectedField/NewSelectedField'
import { downloadCSV } from '../../../../../shared/config/downloadCSV'
const StudentPresence = () => {
  useEffect(() => {
    const today = new Date()

    const year = today.getFullYear()
    const month = String(today.getMonth() + 1).padStart(2, '0') // 01–12
    const day = String(today.getDate()).padStart(2, '0') // 01–31

    const formatted = `${year}-${month}-${day}`

    setSelectedDate(formatted)
  }, [])
  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type
  const [page, setPage] = useState(1)
  const [selectedGrade, setSelectedGrade] = useState('')
  const [selectedClass, setSelectedClass] = useState('')
  const [selectedMonth, setSelectedMonth] = useState('')
  const [selectedDate, setSelectedDate] = useState('')
  // console.log('---selectedDate',selectedDate);
  const [year, month, day] = selectedDate.split('-')

  const [selectedStatus, setSelectedStatus] = useState('')
  const dispatch = useDispatch()
  // console.log('----customRole',customRole);

  const [openSchoolInfo, setSchoolInfo] = useState(false)
  const [search, setSearch] = useState('')
  const rowsPerPage = useSelector((state) => state.global.rowsPerPage)

  const [schoolName, setSchoolName] = React.useState('')
  // console.log('-----schoolName', schoolName)

  const {
    data: studentRow,
    count,
    totalAbsent,
    totalAttendance,
    totalPresent,
    totalLeave,
    refetch
  } = useGlobal({
    userUrl: `${urls.PRESENCE_GET}?school_id=${customRole == 'Admin' ? userSchoolId : schoolName}&page=${page}&limit=${rowsPerPage}&grade_id=${selectedGrade}&section_id=${selectedClass}&status=${selectedStatus}&employee_type=Student&month=${month}&date=${day}&year=${year}&keyword=${search}`,
  })
  const analyticsData = [
    {
      title: 'Total Students',
      content: totalAttendance,
    },
    {
      title: 'Present',
      content: totalPresent,
    },
    {
      title: 'Absent',
      content: totalAbsent,
    },
    {
      title: 'On Leave',
      content: totalLeave,
    },
  ]
  const [feeStatus, setFeeStatus] = useState('')
  const [gradeValue, setGradeVal] = useState('')
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=${page}&limit=${highestInt}`,
  })
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name

  // const { data: searchstudent, count: searchcount } = useGlobal({
  //   userUrl: `${urls.STUDENT_SEARCH}${search}&grade_id=${selectedGrade}&fee_status=${feeStatus}&school_id=${customRole == 'Admin' ? userSchoolId : schoolName}&page=${page}&limit=${rowsPerPage}`,
  // })

  const { data: grades } = useGlobal({
    userUrl: `${urls.CLASS_GRADE}${customRole == 'Admin' ? userSchoolId : schoolName}&page=1&limit=10000`,
  })

  // console.log('---grades', grades)

  // const [update, setUpdate] = useState(false)
  // const [detail, setDetail] = useState(false)

  // const rowData = search || gradeValue || feeStatus || selectedGrade ? searchstudent : studentRow
  const rowData = studentRow

  // console.log('----rowData',rowData);

  const handleOpen = () => {
    dispatch(setOpenTransportModal(true))
  }

  const no_data_msg =
    customRole == 'Admin'
      ? 'Please Select A Grade and Class'
      : schoolName
        ? 'Select school to see Students'
        : 'Select school to see Students'
  const pagecount = count
  const handleGradeChange = (event) => {
    const value = event.target.value
    setSelectedGrade(value)
    console.log('Selected grade:', value)
    // You can pass this value to parent or apply filter here
  }

  const handleClassChange = (event) => {
    const value = event.target.value
    setSelectedClass(value)
    console.log('Selected class:', value)
    // You can pass this value to parent or apply filter here
  }
  const handleMonthChange = (event) => {
    const value = event.target.value
    setSelectedMonth(value)
    // console.log('Selected month:', value)
    // You can pass this value to parent or apply filter here
  }
  const handleStatusChange = (event) => {
    const value = event.target.value
    setSelectedStatus(value)
    // console.log('Selected status:', value)
    // You can pass this value to parent or apply filter here
  }
  const [statusOpen, setStatusOpen] = useState(false)
  const handleExport = () => {
    if (rowData && rowData.length > 0) {
      // Generate filename with date and filters
      const dateStr = selectedDate || new Date().toISOString().split('T')[0]

      let filename = `Student_Presence_${dateStr}`

      if (selectedGrade) {
        const gradeName = grades?.find((g) => g.grade_id === selectedGrade)?.grade || selectedGrade
        filename += `_Grade_${gradeName}`
      }

      if (selectedClass) {
        filename += `_Class_${selectedClass}`
      }

      if (selectedStatus) {
        filename += `_${selectedStatus}`
      }

      downloadCSV(rowData, filename)
    } else {
      alert('No data to export')
    }
  }
  return (
    <div>
      <Toolbar />
      <DashboardHead title={'Student'} count={count} subtitle={'Presence / Students'} />
      <div className={classes.analyticsContainer}>
        {analyticsData.map((card, index) => (
          <DashboardCard key={index} title={card.title} content={card.content} />
        ))}
      </div>
      <div className="school-toolbar">
        <div style={{ width: '40%' }}>
          {customRole != 'Admin' ? (
            <SelectField
              placeholder={'Select School'}
              options={(schoolList || [])?.map((prod) => ({
                value: prod.school_id,
                label: prod.school_name,
              }))}
              name="schoolName"
              value={schoolName}
              onChange={(selectedOption) => setSchoolName(selectedOption)}
              setPage={setPage}
            />
          ) : (
            <InfoField value={userSchoolName} />
          )}
        </div>
      </div>
      <ToolbarComponent
        handleOpen={handleOpen}
        width={'fit-content'}
        transport={true}
        search={search}
        setSearchItem={setSearch}
        StudentPresence
      >
        {/* <FilterStudent
          feeStatus={feeStatus}
          setFeeStatus={setFeeStatus}
          gradeValue={gradeValue}
          setGradeVal={setGradeVal}
          school_id={
            customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : schoolName
          }
        /> */}
        <NewSelectedField
          studentPresence={true}
          selectedGrade={selectedGrade}
          selectedMonth={selectedMonth}
          selectedClass={selectedClass}
          selectedDate={selectedDate}
          handleStatusChange={handleStatusChange}
          setSelectedDate={setSelectedDate}
          school_id={customRole == 'Admin' ? userSchoolId : schoolName}
          handleGradeChange={handleGradeChange}
          grades={grades}
          handleClassChange={handleClassChange}
          handleMonthChange={handleMonthChange}
          setSelectedClass={setSelectedClass}
          setSelectedGrade={setSelectedGrade}
          setSelectedMonth={setSelectedMonth}
          setSelectedStatus={setSelectedStatus}
          status={selectedStatus}
          setStatus={setSelectedStatus}
        />

        {/* <ExportFile icon={FilterIcon} filename={'student'} jsonData={studentRow || []} /> */}
        <FilterSection icon={ImportIcon} onClick={handleExport} title={'Export'} />
        {/* <FilterSection
          icon={ExportIcon}
          onClick={() => dispatch(setOpenImport(true))}
          title={'Import'}
        /> */}
      </ToolbarComponent>
      {rowData?.length === 0 ? (
        no_data_msg
      ) : (
        <DataTable
          headCells={studentPresenceHeadCells}
          rowData={rowData}
          StudentPresence
          pages
          pageFee={page}
          noDataMsg={no_data_msg}
          setPageFee={setPage}
          school={false}
          search={search}
          // setUpdate={setUpdate}
          pageCount={pagecount}
          refetch={refetch}
          // count={count}
          // handleDetailOpen={() => setDetail(true)}
        />
      )}
    </div>
  )
}

export default StudentPresence
